import React, { useContext, useMemo } from "react";

import RegressionWidgetHeader from "../RegressionWidget/regressionWidgetHeader";
import RegressionWidgetFooter from "../RegressionWidget/regressionWidgetFooter";
//Highcharts
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsItemSeries from "highcharts/modules/item-series";

//Context
import DataHandling from "../../utils/dataHandling";
import {
  config_lineChartEV,
} from "../../models/diagramsConfig";
import { GetDataContext } from "../../context/GetDataContext";

//Highcharts Modules
HighchartsItemSeries(Highcharts);

const RegressionV2 = () => {
  //Data
  const {
    evData,
    appConfigOptions,
  } = useContext(GetDataContext);
  //Filtering
  const filter = {value: 0, label: 'ΟΛΕΣ ΟΙ ΕΤΑΙΡΙΕΣ'}; // Hard coded filter object with zero because we need all companies

  useMemo(() => {
    if (evData.data.length > 0) {
        DataHandling(evData, filter, appConfigOptions)
    }
  }, [ evData, appConfigOptions]);

  return (
    <div className="regression regression-widgetV2">
      <RegressionWidgetHeader />
      <section className={"container container-evaluation"}>
        <HighchartsReact
          highcharts={Highcharts}
          options={config_lineChartEV}
          updateArgs={[true, true, true]}
        />
      </section>
      <RegressionWidgetFooter />
    </div>
  );
};

export default RegressionV2;
